'use strict';

/**
 * @classname MymenuOpen
 * @classdesc マイメニューの下層メニューをオープンする
 */
export default class MymenuOpen {
	/**
	 * @constructor
	 * @param {jQuery} $e - 該当する jQuery オブジェクト
	 * @param {instance} controller - controller オブジェクト
	 */
	constructor($e) {
		console.log('MymenuOpen.constructor');
		this._$e = $e;
		this._$target = $(`#${$e.attr('data-target')}`)
		$e.find('.flex').on('click', (e) => this.onClick(e));

		// this._$target.find('.anchor').each((idx, el) => {
		// 	const $el = $(el)
		// 	$el.on('click', function(event) {
		// 		event.preventDefault();
		// 		console.log('preventDefault');
		// 	});
		// })
	};


	/**
	 * クリックイベントのコールバック
	 *
	 * @memberof MymenuOpen
	 * @return {undefined}
	 */
	onClick(e) {
		console.log('MymenuOpen.onClick');
		this._$e.toggleClass('open')
	}
};